@if (!isLoading()) {
  <div [ngClass]="{ inline: isInline(), rows: !isInline() }">
    <label class="form-field-label" [for]="name()">
      {{ label() }}
      @if (!isReadOnly() && !hideRequiredIcon()) {
        {{
          ngControl?.control != null && (ngControl!.control! | abstractControlToFormControl).hasValidator(Validators.required) ? " *" : null
        }}
      }
      @if (labelTooltip() || labelTooltipIcon()) {
        <shared-icon
          [icon]="labelTooltipIcon()?.name || 'info-square'"
          [fill]="labelTooltipIcon()?.color"
          [height]="labelTooltipIcon()?.height"
          [width]="labelTooltipIcon()?.width"
          [pTooltip]="labelTooltip()" />
      }
    </label>
    <div class="content" [ngClass]="{ needsEllipsis: needsEllipsis() }" [pTooltip]="contentTooltip()">
      <ng-content />
    </div>

    @if (!isReadOnly()) {
      <div class="validation-messages">
        <div class="custom-validation-message" #customValidationMessage>
          <ng-content select="[validation]" />
        </div>

        @if (ngControl?.control != null && !customValidationMessage.hasChildNodes()) {
          <shared-validation-message [control]="ngControl!.control! | abstractControlToFormControl" [inputNumber]="inputNumberChild()" />
        }
      </div>
    }
  </div>
} @else {
  <p-skeleton height="1.5rem" styleClass="mb-2" />
}
